export default __webpack_public_path__ + "static/media/2120.9b48fd97.png";